/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
// Routes
import paths from './paths'

function route (path, view, props, children, meta, name) {
  return {
    name: name || view.replace(/\//g, '-').toLowerCase(),
    props,
    path,
    meta,
    component: (resovle) => {
      import(
      '@/views/' + view + '.vue'
        ).then(resovle)
    },
    children: children && children.length ? children.map(subpath => route(
      path + '/' + subpath.path,
      subpath.view,
      subpath.props,
      subpath.children,
      subpath.meta,
      subpath.name
    )) : []
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.props, path.children, path.meta, path.name)).concat([
    { path: '*', redirect: '/home' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    if (from.name === to.name && to.meta.noScroll) {
      return null
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: true
    }
  })
}

export default router
